import { URL_SERVICE } from "../shared/constants/api-constants";
import { axiosInstance } from '../shared/services/axios-instance';

class ProductServices {
    // brings reward's rating info
    static rateProductId(config, payload) {
        return axiosInstance.get(URL_SERVICE + "/rating/api/v1/rate-product-id/" + payload, config).then(resp => resp.data)
    }

    static qualifyProduct(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/rating/api/v1/rate", payload, config).then(resp => resp.data)
    }

    // brings all reward's rating info
    static allRateProduct(config, payload) {
        return axiosInstance.get(URL_SERVICE + "/rating/api/v1/all-rate-product/" + payload, config).then(resp => resp.data)
    }


}

export default ProductServices;